import '../../styles/Ceo.css';

export function Ceo({ ceo }) {
  const ceoImg = `./img/${ceo.img}`;
  return(
    <>
      <div className="box">

          <div className="media-center has-text-centered img-ceo-container">
            <a href={ceo.links[0].url} target="_blank" className='img-ceo'>
              <figure className="image is-64x64">
                <img src={ceoImg} alt="ceo" />
              </figure>
            </a>
            
            <p>
              <strong>{ceo.title}</strong> <small>CEO</small>
            </p>
          </div>
          <div className="media-content">
            <div className="content">
              <p className="has-text-centered">
                <i>
                  <small>
                    {ceo.text}
                  </small>
                </i>
              </p>
            </div>
            <nav className="level is-mobile">
              <div className="level-left">
                <a className="level-item" aria-label="reply">
                  <span className="icon is-small">
                    <i className="fas fa-reply" aria-hidden="true"></i>
                  </span>
                </a>
                <a className="level-item" aria-label="retweet">
                  <span className="icon is-small">
                    <i className="fas fa-retweet" aria-hidden="true"></i>
                  </span>
                </a>
                <a className="level-item" aria-label="like">
                  <span className="icon is-small">
                    <i className="fas fa-heart" aria-hidden="true"></i>
                  </span>
                </a>
              </div>
            </nav>
          </div>
  
      </div>
    </>
  );
}